import {
  Flag,
  Gift,
  Lock,
  User,
  Users,
} from './coach-profile-icons'

/**
 * Lucide icon components aligned with programs search format filter chips
 * (private / group / program). The flagged profile shop also uses
 * `packages` (gift) and `access-code` (lock) for overlapping type
 * pills that golf-lessons format chips do not mount.
 */
export const OFFERING_FORMAT_ICON_COMPONENTS = {
  private: User,
  group: Users,
  program: Flag,
  packages: Gift,
  'access-code': Lock,
}

/** Maps Algolia / offering `format` to icon keys used in {@link OFFERING_FORMAT_ICON_COMPONENTS}. */
export function getOfferingFormatIconKey(format) {
  const normalized = String(format || '').trim().toLowerCase()
  if (normalized === 'private') return 'private'
  if (normalized === 'group' || normalized === 'group_clinic') return 'group'
  if (normalized === 'program') return 'program'
  return 'program'
}
